export default "__VITE_PUBLIC_ASSET__fa778f35__"